(function () {
  const slideshowSlide = () => {
    const $slideshowElement = $(".slideshow__slide--initialized").not(
      ".slick-initialized",
    );

    $slideshowElement.slick({
      slidesToShow: 1,
      arrows: false,
      dots: true,
      dotsClass: "slick-dots container",
      autoplay: $slideshowElement[0].dataset.autoplay === "true" ? true : false,
      autoplaySpeed: +$slideshowElement[0].dataset.sliderAutoplay,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      adaptiveHeight: false,
    });

    $(".slideshow__button--next").click(function () {
      $(this)
        .parents(".slideshow")
        .find(".slideshow__slide--initialized")
        .slick("slickNext");
    });
    $(".slideshow__button--prev").click(function () {
      $(this)
        .parents(".slideshow")
        .find(".slideshow__slide--initialized")
        .slick("slickPrev");
    });
  };

  slideshowSlide();

  document.addEventListener("shopify:section:load", function () {
    slideshowSlide();
  });
})();
